import React from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';

import './Tab-Groups.css';

import KeyValuePane from '../Panes/KeyValue/KeyValuePane';
import JsonEditorPane from '../Panes/Json/JsonEditorPane';

export default function RequestTabGroup({
  queryParams,
  setQueryParams,
  headers,
  setHeaders,
  body,
  setBody,
}) {
  const requestTabs = [
    {
      slug: 'query-params',
      title: 'Query Params',
      panel: KeyValuePane,
      paneValue: queryParams,
      setPaneValue: setQueryParams,
      buttonText: 'Add Query Parameter',
    },
    {
      slug: 'headers',
      title: 'Headers',
      panel: KeyValuePane,
      paneValue: headers,
      setPaneValue: setHeaders,
      buttonText: 'Add Header',
    },
    {
      slug: 'body',
      title: 'Body',
      panel: JsonEditorPane,
      paneValue: body,
      setPaneValue: setBody,
    },
  ];

  return (
    <Tabs forceRenderTabPanel selectedTabClassName="border-b-2 border-[#fdb814] text-[#fdb814]" className="flex flex-col h-full">
      <TabList className="flex bg-gradient-to-r from-gray-50 to-white border-b-2 border-gray-200 flex-shrink-0 -mx-6 px-6">
        {requestTabs.map((tab) => (
          <Tab className="py-3 px-6 text-sm font-semibold border-b-2 border-transparent focus:outline-none 
                          hover:text-[#fdb814] hover:border-[#fdb814]/30 cursor-pointer transition-all duration-200" 
              key={tab.slug}>
                {tab.title}
                </Tab>
        ))}
      </TabList>

      {requestTabs.map((tab) => (
        <TabPanel className="react-tabs__tab-panel py-6 px-6 flex-1 overflow-auto bg-white" key={tab.slug}>
          <tab.panel
            paneValue={tab.paneValue}
            setPaneValue={tab.setPaneValue}
            buttonText={tab.buttonText}
          />
        </TabPanel>
      ))}
    </Tabs>
  );
}
